(function () {
  'use strict';

  function initSlideshow(section) {
    if (section.dataset.ckrReady === 'true') return;
    var slides = Array.prototype.slice.call(section.querySelectorAll('.glider-track.slideshow > .glider-slide'));
    if (slides.length < 2) return;
    section.dataset.ckrReady = 'true';
    var current = 0;
    var show = function (index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === current;
        slide.hidden = !active;
        slide.classList.toggle('active', active);
        slide.classList.toggle('visible', active);
      });
    };
    var previous = section.querySelector('.glider-button-prev');
    var next = section.querySelector('.glider-button-next');
    if (previous) previous.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    show(0);
    var carousel = section.querySelector('[data-glider-autorotate="true"]');
    if (carousel) {
      var delay = parseInt(carousel.dataset.gliderAutoplay, 10) || 7000;
      window.setInterval(function () { show(current + 1); }, delay);
    }
  }

  function initTabs(section) {
    if (section.dataset.ckrReady === 'true') return;
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;
    section.dataset.ckrReady = 'true';
    var activate = function (tab) {
      tabs.forEach(function (candidate) {
        var active = candidate === tab;
        candidate.setAttribute('aria-selected', active ? 'true' : 'false');
        candidate.tabIndex = active ? 0 : -1;
        var panel = section.querySelector('#' + CSS.escape(candidate.getAttribute('aria-controls')));
        if (panel) {
          panel.hidden = !active;
          panel.classList.toggle('hide', !active);
          panel.tabIndex = active ? 0 : -1;
        }
      });
    };
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (event) {
        event.preventDefault();
        activate(tab);
      });
    });
    activate(tabs[0]);
  }

  function initCarousel(section) {
    var carousels = Array.prototype.slice.call(section.querySelectorAll('.collection-products.glider'));
    carousels.forEach(function (carousel) {
      if (carousel.dataset.ckrReady === 'true') return;
      carousel.dataset.ckrReady = 'true';
      var id = carousel.id.replace('glider-carousel-', '');
      var previous = section.querySelector('#glider-button-prev-' + CSS.escape(id));
      var next = section.querySelector('#glider-button-next-' + CSS.escape(id));
      var move = function (direction) {
        carousel.scrollBy({ left: direction * Math.max(280, carousel.clientWidth * 0.8), behavior: 'smooth' });
      };
      if (previous) previous.addEventListener('click', function () { move(-1); });
      if (next) next.addEventListener('click', function () { move(1); });
    });
  }

  function init(root) {
    root.querySelectorAll('[data-section-type="slideshow"]').forEach(initSlideshow);
    root.querySelectorAll('[data-section-type="tabbed"]').forEach(function (section) {
      initTabs(section);
      initCarousel(section);
    });
    root.querySelectorAll('[data-section-type="carousel"]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
